module.exports = __webpack_public_path__ + "static/staff-of-homa-364ba448d7bcfc5ed1e336180d07e691.png";